import { isNumber, isString } from '../fold-helpers';
import { createWidgetNormalizer } from '../create-widget-normalizer';

import { LOGO_SOURCE_KEYS } from './partial-logo-widget-data.schema';

const URL_SYNONYM_KEYS = ['src', 'imageUrl', 'imageSrc'] as const;
const MAX_WIDTH_SYNONYM_KEYS = ['width'] as const;
const RADIUS_SYNONYM_KEYS = ['radius', 'cornerRadius'] as const;

/**
 * Unwraps a `data.image` field into the flat `url` — the persisted field really is called that,
 * same reasoning as image's own `foldImageObject`, trimmed to logo's one source key. A model
 * reaching for `image: "https://…"` or `image: { url: "…" }` would otherwise lose it silently: the
 * flat schema has no `image` key, and a plain `z.object()` strips unrecognized keys without a trace.
 */
function foldLogoImageObject(args: Record<string, unknown>, data: Record<string, unknown>): void {
    const image = data['image'] ?? args['image'];
    delete data['image'];

    if (typeof image === 'string') {
        if (data['url'] === undefined) {
            data['url'] = image;
        }
        return;
    }

    if (image == null || typeof image !== 'object' || Array.isArray(image)) {
        return;
    }

    const url = (image as Record<string, unknown>)['url'];

    if (url !== undefined && data['url'] === undefined) {
        data['url'] = url;
    }
}

const logoNormalizer = createWidgetNormalizer({
    before: [foldLogoImageObject],
    rules: [
        { target: 'url', synonyms: URL_SYNONYM_KEYS, accepts: isString },
        { target: 'maxWidth', synonyms: MAX_WIDTH_SYNONYM_KEYS, accepts: isNumber },
        { target: 'borderRadius', synonyms: RADIUS_SYNONYM_KEYS, accepts: isNumber },
    ],
    extraFlatKeys: ['image', ...LOGO_SOURCE_KEYS],
    optionalData: true,
});

export function normalizeLogoWidgetArgs(raw: unknown): unknown {
    return logoNormalizer.normalize(raw);
}
